import React, { useState, useContext, useEffect } from "react";
import "../Styles/MemberProfilePage.css"; // Import CSS styles
import MpCoverImageUploader from "../Utils/CoverImageUploader";
import MPFeedContent from "../Utils/MemberProfile/MemberProfileFetchData";

const MemberProfilePage = ({ userId }) => {
    const [coverImage, setCoverImage] = useState("/assets/images/login_page_img2.jpg");

  return (
    <div className="mp-page-grid">
      <div className="mp-page-grid-upper">
            <MpCoverImageUploader coverImage={coverImage} setCoverImage={setCoverImage} userId={userId}/>
      </div>

      <div className="mp-page-grid-lower">
        <MPFeedContent userId={userId}/>
      </div>
        <div>
          <p className="mp-copyright">
            Kleido AI - An Intelligent Social Platform, Copyright © InitiumNet Technology Pvt Ltd.
          </p>
        </div>
    </div>
  );
};

export default MemberProfilePage;

